export const SET_SURVEY_ANSWERS = 'SET_SURVEY_ANSWERS';
export const UPSERT_SERVEY_ANSWER = 'UPSERT_SERVEY_ANSWER';
export const UPDATE_SURVEY_ANSWER = 'UPDATE_SURVEY_ANSWER';

export const setSurveyAnswers = (sID, answers) => ({
    type: SET_SURVEY_ANSWERS,
    sID,
    answers,
});

export const upsertSurveyAnswer = ({sID, qID, answer, encrypted_field}) => ({
    type: UPSERT_SERVEY_ANSWER,
    sID,
    qID,
    answer,
    encrypted_field
});

export const updateSurveyAnswer = ({sID, qID, answer, encrypted_field}) => ({
    type: UPDATE_SURVEY_ANSWER,
    sID,
    qID,
    answer,
    encrypted_field
});